import axios from 'axios'
const TopicModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH: (state, payload) => {
      state.data = payload
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`portal/topic`)
        commit('FETCH', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Topic was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
  }
}

export default TopicModule
